import React from "react";
import { Icon } from "../UIElements/Icon";
import WalletCard from "./WalletCard";

const WalletsTab = ({ wallets, userId, users = [] }) => {
  if (!wallets || wallets.length === 0) {
    return (
      <div className="space-y-6">
        <div className="py-12 text-center">
          <Icon
            name="Wallet"
            className="text-muted-foreground mx-auto mb-4 h-12 w-12"
          />
          <h3 className="text-foreground mb-2 text-lg font-semibold">
            No Wallets Found
          </h3>
          <p className="text-muted-foreground">
            This user doesn&apos;t have any wallets configured.
          </p>
        </div>
      </div>
    );
  }

  // Sort wallets by ID (ascending order - smaller ID first)
  const sortedWallets = [...wallets].sort((a, b) => a.id - b.id);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
        {sortedWallets.map((wallet) => (
          <WalletCard
            key={wallet.id}
            wallet={wallet}
            userId={userId}
            users={users}
          />
        ))}
      </div>
    </div>
  );
};

export default WalletsTab;
